export const confApp = {
  // API_URL: "https://api.nefrosys.net/api/",
  API_URL: "https://api-pruebas.nefrosys.net/api/",

  // LINK_DOC: "https://consultorio-digital.com/Docs/Negocios",
  // LINK_DOC: "https://dev.s-digitales.com/Docs/Negocios",
  // LINK_DOC: "https://localhost:7008/Docs/Negocios"

  // API_URL: "https://localhost:7008/api/",
  // LINK_DOC: "https://localhost:7008/Docs/Negocios",
  VERSION: "2.30.5",
  NIVEL_ESTUDIO: [
    { label: "Preescolar", value: "Preescolar" },
    { label: "Primaria", value: "Primaria" },
    { label: "Secundaria", value: "Secundaria" },
    { label: "Bachillerato", value: "Bachillerato" },
    { label: "Licenciatura", value: "Licenciatura" },
    { label: "Maestría", value: "Maestría" },
    { label: "Doctorado", value: "Doctorado" },
    { label: "Otros", value: "Otros" },
  ],
  VALORES_SATURACION_OX: [
    { valorMin: 95, valorMax: 99, estado: "Normal" },
    { valorMin: 91, valorMax: 94, estado: "Revisar condición" },
    { valorMin: 0, valorMax: 90, estado: "Requiere atención" },
    { valorMin: 100, valorMax: 200, estado: "Saturación eleveda" },
  ],
  VALORES_HEPARINA_BOLO: [
    { label: "0", value: "0" },
    { label: "500", value: "500" },
    { label: "1000", value: "1000" },
    { label: "1500", value: "1500" },
    { label: "2000", value: "2000" },
  ],
  VALORES_HEPARINA_INFUSION: [
    { label: "0", value: "0" },
    { label: "500", value: "500" },
    { label: "800", value: "800" },
    { label: "1000", value: "1000" },
  ],
  PERFIL_UF_NA: [
    { label: '-', value: '0' },
    { label: '1', value: '1' },
    { label: '2', value: '2' },
    { label: '3', value: '3' },
    { label: '4', value: '4' },
    { label: '5', value: '5' },
    { label: '6', value: '6' },
    { label: '7', value: '7' },
    { label: '8', value: '8' },
  ],
  LISTA_ACIDO: [
    { label: '-', value: '0' },
    { label: '0K', value: '0K' },
    { label: '2K', value: '2K' },
    { label: '3K', value: '3K' },
  ],
  IMAGES_URL: "Images",
  ESTADOS: [
    { label: "Aguascalientes", value: "Aguascalientes" },
    { label: "Baja California", value: "Baja California" },
    { label: "Baja California Sur", value: "Baja California Sur" },
    { label: "Campeche", value: "Campeche" },
    { label: "Chiapas", value: "Chiapas" },
    { label: "Chihuahua", value: "Chihuahua" },
    { label: "Ciudad de Mexico", value: "Ciudad de Mexico" },
    { label: "Coahuila de Zaragoza", value: "Coahuila de Zaragoza" },
    { label: "Colima", value: "Colima" },
    { label: "Durango", value: "Durango" },
    { label: "Guanajuato", value: "Guanajuato" },
    { label: "Guerrero", value: "Guerrero" },
    { label: "Hidalgo", value: "Hidalgo" },
    { label: "Jalisco", value: "Jalisco" },
    { label: "Mexico", value: "Mexico" },
    { label: "Michoacan de Ocampo", value: "Michoacan de Ocampo" },
    { label: "Morelos", value: "Morelos" },
    { label: "Nayarit", value: "Nayarit" },
    { label: "Nuevo Leon", value: "Nuevo Leon" },
    { label: "Oaxaca", value: "Oaxaca" },
    { label: "Puebla", value: "Puebla" },
    { label: "Queretaro", value: "Queretaro" },
    { label: "Quintana Roo", value: "Quintana Roo" },
    { label: "San Luis Potosi", value: "San Luis Potosi" },
    { label: "Sinaloa", value: "Sinaloa" },
    { label: "Sonora", value: "Sonora" },
    { label: "Tabasco", value: "Tabasco" },
    { label: "Tamaulipas", value: "Tamaulipas" },
    { label: "Tlaxcala", value: "Tlaxcala" },
    {
      label: "Veracruz de Ignacio de la Llave",
      value: "Veracruz de Ignacio de la Llave",
    },
    { label: "Yucatan", value: "Yucatan" },
    { label: "Zacatecas", value: "Zacatecas" },
    { label: "Extranjero", value: "Extranjero" },
  ],
  RELACIONES: [
    { label: 'Esposo(a)', value: 'Esposo(a)' },
    { label: "Padre", value: "Padre" },
    { label: "Madre", value: "Madre" },
    { label: "Hijo(a)", value: "Hijo(a)" },
    { label: "Abuelo(a)", value: "Abuelo(a)" },
    { label: "Nieto(a)", value: "Nieto(a)" },
    { label: "Hermano(a)", value: "Hermano(a)" },
    { label: "Cuñado(a)", value: "Cuñado(a)" },
    { label: "Tio(a)", value: "Tio(a)" },
    { label: "Primo(a)", value: "Primo(a)" },
    { label: "Amigo(a)", value: "Amigo(a)" },
    { label: "Conocido(a)", value: "Conocido(a)" },
  ],
};
